<template>
  <v-row dense justify="center">
    <v-col cols="12" class="content">
      <v-card>
        <v-form ref="form">
          <v-col cols="12">
            <v-row align="center" justify="center">
              <v-col :cols="12" sm="4">
                <BaseDatePicker ref="date"
                                :rules="[() => !!date || 'Поле обязательно']"
                                :error-messages="errorMessages"
                                :value="date"
                                :disabled="dialogLoading"
                                :picker-type="'month'"
                                @dateUpdated="setDate"
                                label="Дата"
                                style="padding-right: 20px;"
                                required />
              </v-col>
              <v-col :cols="12" sm="2">
                <v-text-field ref="hours"
                              v-model="hours"
                              :rules="[() => !!hours || 'Поле обязательно']"
                              label="Количество часов" />
              </v-col>
              <!--              <v-col v-for="product in globalProds"-->
              <!--                     :key="product.value"-->
              <!--                     cols="12"-->
              <!--                     lg="3">-->
              <!--                <v-text-field v-model="product.amount" :label="product.name" />-->
              <!--              </v-col>-->
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row align="center" justify="center">
              <v-btn
                @click="submitReport"
                color="primary"
                class="mb-2">
                Начать
              </v-btn>
            </v-row>
          </v-col>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

import {mapState} from 'vuex'
import BaseDatePicker from '../../base/BaseDatePicker'
import ReportsMixin from '../new/ReportsMixin'

export default {
  name: "ReportLawyersNew",
  components: {BaseDatePicker},
  mixins: [ReportsMixin],
  props: {
    reportId: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      errorMessages: '',
      dialogLoading: false,
      dateRules: [
        v => !!v || 'Поле обязательно',
        v => this.isValidDate(v) || 'Неверная дата'
      ],
      numericRules: [
        v => !!v || 'Поле обязательно',
        v => !isNaN(v) || 'Допустимы только численные значения'
      ]

    }
  },
  computed: {
     globalProds: {
       get () {
         let vm = this
         let filtered = []
         if (vm.globalIndicatorsList && vm.globalIndicatorsList.length > 0) {
           filtered = vm.globalIndicatorsList.filter(v => v.report_type.indexOf(vm.reportTypes[vm.$route.meta.reportType]) > -1)
           filtered.map(v => {
                 v['amount'] = v['name'] === 'Количество кейсов' ? vm.customers.length : v['amount']
                 v['readOnly'] = v['name'] === 'Количество кейсов'
                 return v
               }
           )
           this.$store.commit("newOutreachReports/setglobalIndicators", filtered)

         }
         return filtered
       },
       set (indicator) {
         this.$store.commit("newOutreachReports/setglobalIndicators", indicator)
       },
     },
    reportType () {
      return this.$route.meta.reportType
    },
    ...mapState({
      date: state => state.newOutreachReports.date,
      consultingsList: state => state.tableData.products,
      employees: state => state.newOutreachReports.users,
      globalIndicatorsList: state => state.tableData.globalIndicators

    }),
    hours: {
      get () {
        return this.$store.state.newOutreachReports.hours
      },
      set (hours) {
        this.$store.commit("newOutreachReports/setHours", hours)
      }
      }
    },
  mounted: function () {
      if (this.reportId === 'new') {
        this.setEmlpoyees([this.$store.state.authentication.user.user_info.id])
      }
    },
  methods: {
    submitReport () {
      if (this.validate()) {
        this.$router.push({name: 'ReportLawyerList'})
      }
    },
    setDate (e) {
      this.$store.commit("newOutreachReports/setDate", e)
    },
    setEmlpoyees (e) {
      this.$store.commit("newOutreachReports/setEmlpoyees", e)
    },
    validate () {
      return this.$refs.form.validate()
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-dialog {
  background-color: #303030
}

.outreach-header {
  background-color: #1976d2 !important;
  opacity: 0.8;
  padding: 10px
}

.case-header {
  background-color: #ffc107 !important;
  opacity: 0.8;
  padding: 10px
}

.read-only-header {
  background-color: gray !important;
  opacity: 0.8;
  padding: 10px
}

.content {
  max-width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/new/ReportLawyersNew.vue